import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "2d67dc97-cd3b-41ce-ac85-ad49026201d3",
    content: "T = 0,6 s, speech intelligibility is increased",
    options: {},
  },
  {
    id: "6b06c7da-9db7-453e-9b83-57f29fc62770",
    content: "T = 0,46 s , the speech intelligibity is increased",
    options: {},
  },
  {
    id: "daa4bfc1-1554-4d22-bbb6-aef9fdfe0db4",
    content: "T = 0,72 s, speech intelligibilty is decreased",
    options: {},
  },
  {
    id: "60d88ed0-6069-4f52-9f08-f247f0f8494f",
    content: "T = 1 s,  the speech intelligibilty can not be estimated",
    options: {},
  },
];

export const task: Task = {
  id: "fe67f85c-d439-48f8-b026-623755c2d6d3",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  solutionType: "select",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6b06c7da-9db7-453e-9b83-57f29fc62770"],
};
